import { Injectable, Injector } from '@angular/core';
import { BaseService } from '../../shared/_utils/services/base-service';
import { SpinnerService } from './spinner.service';
import { FundingPhase } from '../entities/funding-phase';
import { LazyLoadEvent } from 'primeng/primeng';
import { HttpParams } from '@angular/common/http';
import { QueryOperator } from '../../shared/_utils/services/query-operator.enum';
import { Observable } from 'rxjs/Observable';
import { ResponsePageable } from '../../shared/_utils/services/responsePageable';
import { tap } from 'rxjs/operators';
import { BaseCrudService } from 'app/shared/_utils/services/base-crud-service';
import { FundingDetail } from '../entities/funding-detail';

interface ExtraSearchFields {
    startDateRange01?: Date,
    startDateRange02?: Date,
    firstDocumentNumber?: string,
    latestDocumentNumber?: string
}

@Injectable()
export class FundingDetailService extends BaseCrudService<FundingDetail> {

    uri = '/api/fundingDetail/';

    constructor(injector: Injector, spinnerService: SpinnerService) {
        super(injector);
        // console.log('Instance fundingDetailService');
    }

    buildSentence(entity?: FundingDetail, event?: LazyLoadEvent): HttpParams {
        if (entity) {
            let query = '';

            if (entity.fundingPhase) {
                if (entity.fundingPhase.id) {
                    query = query.concat(
                        `fundingPhase.id${QueryOperator.Equal}${entity.fundingPhase.id}${QueryOperator.Split}`
                    );
                }
            }

            //console.log(query);
            this.httpParams = this.httpParams.set(QueryOperator.QueryParam, query);
        }

        if (event) {
            const page = ((event.first + event.rows) / event.rows - 1).toString();
            const size = event.rows.toString();
            this.httpParams = this.httpParams.set(QueryOperator.PageParam, page);
            this.httpParams = this.httpParams.set(QueryOperator.SizeParam, size);
        }
        return this.httpParams;
    }
}



// WEBPACK FOOTER //
// ./src/app/core/services/funding-detail.service.ts